import { defineNuxtPlugin } from '#app'

// Altcha is loaded on-demand by AltchaWidget — keep this plugin as a no-op
// so we do not pay the parse cost on every page.
export default defineNuxtPlugin(() => {})
